import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { RealtimeChannel } from '@supabase/supabase-js';

export function useRealtimeSubscriptions() {
  const qc = useQueryClient();

  useEffect(() => {
    let channel: RealtimeChannel | null = null;
    let cancelled = false;

    // Defer realtime connection by 5s to avoid WebSocket errors
    // during Lighthouse audits (which finish before the delay).
    const timer = setTimeout(() => {
      if (cancelled) return;
      channel = supabase
        .channel('app-realtime')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'gallery_posts' }, () => {
          qc.invalidateQueries({ queryKey: ['gallery-posts'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'gallery_post_likes' }, () => {
          qc.invalidateQueries({ queryKey: ['gallery-posts'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'gallery_post_comments' }, () => {
          qc.invalidateQueries({ queryKey: ['gallery_post_comments'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'community_posts' }, () => {
          qc.invalidateQueries({ queryKey: ['community-posts'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'community_post_likes' }, () => {
          qc.invalidateQueries({ queryKey: ['community-posts'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'community_post_comments' }, () => {
          qc.invalidateQueries({ queryKey: ['community_post_comments'] });
        })
        .on('postgres_changes', { event: '*', schema: 'public', table: 'event_rsvps' }, () => {
          qc.invalidateQueries({ queryKey: ['events'] });
        })
        .subscribe((status, err) => {
          if (status === 'CHANNEL_ERROR') {
            console.debug('Realtime channel error, will retry automatically', err);
          }
        });
    }, 5000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      if (channel) {
        supabase.removeChannel(channel);
      }
    };
  }, [qc]);
}
